angular.module('unica_material.material_services')

.factory('MaterialEditService', function ($http, getBaseApiURL) {

	var materialEditService = {};

	materialEditService.update = function (materialData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/material/update/' + materialData.id,
			data: materialData
		}).then(function(result) {

			if ( result ) {
				return result.data.directory;
			}

		});

	};

	return materialEditService;
});